export default class Tool {
  constructor(editor) {
    this.editor = editor;

    // context
    this.contextMenuOptions = {
      canDublicateObject: false,
      canDeleteLayer: false,
      canDublicateLayer: false,
    };

    this.toolOptions = {};
    this.shortcut = null;
  }

  // registerShortcut() {
  //     throw new Error('Method "registerShortcut" should be implemented');
  // }
  render() {}

  getCurrentBreakpoint() {
    return this.editor.getters.getBreakpoint();
  }

  setZoom() {}

  handleVisibilityChange(layer, isVisible) {}

  setPresetStyles(styles) {
    this.styles = styles;
  }

  handleCursorClick(data = null) {}

  getCenterCoords(layer) {
    return null;
  }

  getDefaultContextMenuItems(layer) {
    const hide = {
      type: "link",
      label: "Hide",
      icon: "EyeOffIcon",
      action: () => {
        layer.visible = 0;
        this.handleVisibilityChange(layer, layer.visible);
      },
    };
    const show = {
      type: "link",
      label: "Show",
      icon: "EyeIcon",
      action: () => {
        layer.visible = 7;
        this.handleVisibilityChange(layer, layer.visible);
      },
    };
    // const saveToPreset = {
    //   type: "saveToPreset",
    //   label: "Save To Preset",
    //   icon: "FilePlusIcon",
    //   name: "createPreset",
    //   layer: layer
    // }
    const applyCurrentPreset = {
      type: "link",
      label: "Apply current preset",
      icon: "FileOutputIcon",
      name: "applyPreset",
      layer
    }
    const createPreset = {
      type: "link",
      label: "Create preset",
      icon: "FilePlusIcon",
      name: "createPreset",
      layer
    }
    const addToPreset = {
      type: "link",
      label: "Add to preset",
      icon: "FileInputIcon",
      name: "addToPreset",
      layer
    }
    const items = [
      layer.visible ? hide : show,
      applyCurrentPreset,
      createPreset,
      addToPreset,
      {
        type: "divider",
      },
      {
        type: "link",
        label: "Delete",
        name: "delete",
        icon: "Trash",
        class: "text-danger",
        action: () => {
          this.delete(layer);
        },
      },
      // {
      //   type: "link",
      //   label: "Zoom in",
      //   icon: "ZoomIn",
      //   action: () => {
      //     this.editor.toolManager.tools.panZoom.shortcutZoom({
      //       layer: layer,
      //       context: "zoomIn",
      //     });
      //   },
      // },
      // {
      //   type: "link",
      //   label: "Zoom out",
      //   icon: "ZoomOut",
      //   action: () => {
      //     this.editor.toolManager.tools.panZoom.shortcutZoom({
      //       layer: layer,
      //       context: "zoomOut",
      //     });

      //     // this.delete(type, elem);
      //   },
      // },
    ];

    items.unshift();
    return items;
  }

  getShortcuts() {
    return [];
  }

  getToolFields() {}

  handleClick(data) {
    return;
  }

  handleContextMenu(data) {
    return;
  }

  handleMouseUp(data) {
    return;
  }

  handleMouseMove(event) {
    return;
  }

  handleMouseDown(event) {
    return;
  }

  handleMouseLeave(event) {
    return;
  }
}
